<template>
  <!-- A note on a feed row, on its own full-width line: two lines, then "Show more" -->
  <div class="row-note">
    <i class="fa-regular fa-note-sticky row-note__icon" aria-hidden="true"></i>
    <div class="row-note__body">
      <div ref="text" class="row-note__text" :class="{ 'is-clamped': !expanded }"><span v-if="label" class="font-semi">{{ label }}: </span>{{ text }}</div>
      <div v-if="overflowing || expanded || editable" class="row-note__actions">
        <button v-if="overflowing || expanded" type="button" class="row-note__toggle" @click="expanded = !expanded">{{ expanded ? 'Show less' : 'Show more' }}</button>
        <!-- Edit sits with the note it edits, not in the row's button column -->
        <button v-if="editable" type="button" class="row-note__toggle" @click="$emit('edit')">Edit</button>
      </div>
    </div>
  </div>
</template>
<script>
// Notes on payment follow-ups and subscription events (charges.scss)
export default {
  name: 'row-note',
  props: {
    text: { type: String, required: true },
    // e.g. "From subscriber"
    label: { type: String, default: null },
    // Show an Edit link; emits 'edit'
    editable: { type: Boolean, default: false },
  },
  data() {
    return {
      expanded: false,
      overflowing: false,
    };
  },
  watch: {
    text() {
      this.$nextTick(this.measure);
    },
  },
  mounted() {
    this.measure();
    // Re-measure when the width changes or a hidden tab is shown (a note
    // rendered in a hidden tab pane measures zero height)
    this.observer = new ResizeObserver(() => this.measure());
    this.observer.observe(this.$refs.text);
  },
  destroyed() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  methods: {
    // Only offer "Show more" when the two-line clamp actually hides something
    measure() {
      const el = this.$refs.text;
      if (el && !this.expanded) {
        this.overflowing = el.scrollHeight > el.clientHeight + 1;
      }
    },
  },
};
</script>
